import React, { useState, forwardRef } from 'react';
import {
  Autocomplete,
  Box,
  Button,
  InputAdornment,
  InputBase,
  Menu,
  MenuItem as MuiMenuItem,
  menuItemClasses,
  styled,
  TextField,
  TextFieldProps,
} from '@mui/material';
import { ArrowDropDown } from '@mui/icons-material';
import { JItem } from '../../forms/jformik/jformik.types';
import { useJFormikContext } from '../jformik/jformik.context';
import { Field, FieldProps } from 'formik';

export const FEmailFromInput = forwardRef((jItem: JItem, ref) => {
  const { disabled = false, disableSubmitOnEnter = true } = useJFormikContext();
  const [inputValue, setInputValue] = useState<string>('');
  const {
    multiple = false,
    freeSolo = false,
    freeSoloFormat,
    limitTags,
    name,
    label,
    options,
    tooltip,
  } = jItem;
  return (
    <Field name={jItem.name} innerRef>
      {({
        field: { name, value, onChange },
        form: { touched, errors, setFieldValue, values, submitCount },
      }: FieldProps) => {
        return (
          // <InputBase
          //   fullWidth
          //   disabled={disabled || jItem.disabled}
          //   startAdornment={
          //     <InputAdornment
          //       position="start"
          //       sx={{
          //         color: theme => theme.palette.text.disabled,
          //       }}
          //     >
          //       From:{' '}
          //     </InputAdornment>
          //   }
          //   sx={{
          //     paddingY: 1.2,
          //     paddingRight: 4.5,
          //     borderBottom: theme =>
          //       `1px solid ${theme.palette.action.disabledBackground}`,
          //     color: theme => theme.palette.primary.main,
          //     fontWeight: 400,
          //     fontSize: 14,
          //   }}
          //   value={value}
          //   onChange={onChange}
          // />
          <Autocomplete
            disabled={disabled || jItem.disabled}
            autoSelect
            onChange={(event: any, newValue: any) => {
              setFieldValue(name, newValue);
            }}
            value={value}
            options={
              options
                ? typeof options === 'function'
                  ? options(values)
                  : options
                : []
            }
            getOptionLabel={(option: any) => {
              if (typeof option === 'string') {
                return option;
              } else {
                return (
                  option?.label ||
                  option?.title ||
                  option?.name ||
                  option?.email ||
                  ''
                );
              }
            }}
            renderInput={(params: TextFieldProps) => {
              return (
                <TextField
                  {...params}
                  onKeyPress={e => {
                    disableSubmitOnEnter &&
                      e.key === 'Enter' &&
                      e.preventDefault();
                  }}
                  sx={{
                    paddingLeft: 0,
                    paddingRight: 1,
                    boxSizing: 'border-box',
                    '.MuiOutlinedInput-root': {
                      padding: 0,
                    },
                    '.MuiOutlinedInput-notchedOutline': {
                      borderWidth: `0px !important`,
                    },
                    borderBottom: theme =>
                      `1px solid ${theme.palette.action.disabledBackground}`,
                  }}
                  InputProps={{
                    ...params.InputProps,
                    sx: {
                      color: theme => theme.palette.primary.main,
                      fontWeight: 400,
                      fontSize: 14,
                    },
                    startAdornment: (
                      <>
                        <InputAdornment
                          position="start"
                          sx={{
                            color: theme => theme.palette.text.disabled,
                          }}
                        >
                          From:{' '}
                        </InputAdornment>
                        {params?.InputProps?.startAdornment}
                      </>
                    ),
                  }}
                />
              );
            }}
            autoHighlight
            {...jItem.jItemProps}
            {...(jItem?.jItemProps?.renderTags
              ? {
                  renderTags: (val: readonly string[], getTagProps: any) =>
                    jItem.jItemProps.renderTags(value, getTagProps),
                }
              : {})}
          />
        );
      }}
    </Field>
  );
});

interface EmailChipProps {
  label?: string;
}

const EmailChip = ({ label = 'No email' }: EmailChipProps) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Box>
      <Button
        endIcon={
          <ArrowDropDown
            sx={{
              marginLeft: -0.5,
            }}
          />
        }
        onClick={handleClick}
        sx={{
          fontWeight: 400,
          textTransform: 'unset',
          marginRight: 0.5,
        }}
      >
        {label}
      </Button>

      <Menu
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        onClose={handleClose}
        PaperProps={{
          sx: {
            minWidth: 120,
          },
        }}
      >
        <MenuItem onClick={handleClose}>Option 1</MenuItem>
        <MenuItem onClick={handleClose}>Option 2</MenuItem>
        <MenuItem onClick={handleClose}>Option 3</MenuItem>
      </Menu>
    </Box>
  );
};

const MenuItem = styled(MuiMenuItem)(({ theme }) => ({
  [`&.${menuItemClasses.root}`]: {
    fontSize: 14,
    color: theme.palette.primary.main,
  },
}));
